<template>
  <div class="biz-score-picker">
    <el-popover v-model="visible"
                popper-class="biz-score-picker-popover"
                :trigger="trigger"
                :placement="placement"
                v-bind="$attrs">
      <div class="biz-score-picker-cont">
        <BizScorePickerWrap ref="wrap"
                            :score-alias="scoreAlias"
                            :display-fraction="displayFraction"
                            :pass-score="passScore"
                            v-bind="$attrs"
                            @ready="handleReady"
                            @select="handleSelect"></BizScorePickerWrap>
      </div>
      <template slot="reference">
        <template v-if="$scopedSlots.default">
          <slot :score="value"
                :state="state"
                :on-input="onInput"
                :pretty="handlePretty"
                :is-fail="scoreFail"
                :is-err="scoreErr"
                :show="show"
                :hide="hide"></slot>
        </template>
        <template v-else>
          <el-input v-model="input"
                    type="text"
                    :class="['biz-score-picker-input', {'is-fail': scoreFail}, {'is-err': scoreErr}]"
                    :size="size"
                    :placeholder="placeholder"
                    @blur="handlePretty">
            <template #suffix>
              <template v-if="state">
                <span v-if="state.type === 'success'"
                      class="state-success">
                  <i class="el-icon-success"></i>
                </span>
                <span v-else
                      class="state-fail">
                  <i class="el-icon-error"></i>
                </span>
              </template>
            </template>
          </el-input>
        </template>
      </template>
    </el-popover>
  </div>
</template>

<script>
import BizScorePickerWrap from './wrap'
import scoreComputeUtils from '../../../../util/biz/scoreComputeUtils'
export default {
  name: 'BizScorePicker',
  components: {
    BizScorePickerWrap
  },
  props: {
    value: String,
    size: {
      type: String,
      default: 'mini'
    },
    trigger: {
      type: String,
      default: 'click'
    },
    placement: {
      type: String,
      default: 'right'
    },
    placeholder: String,
    scoreAlias: Object,
    displayFraction: Boolean,
    passScore: {
      type: Number,
      default: 60
    }
  },
  data () {
    return {
      visible: false,
      input: this.value,
      ready: false
    }
  },
  computed: {
    state () {
      if (this.ready) {
        let wrap = this.$refs.wrap
        if (wrap) {
          if (this.input) {
            return wrap.resolveScore(this.input)
          }
        }
      }
    },
    scoreFail () {
      let state = this.state
      if (state && state.type === 'success') {
        let data = state.data
        if (data) {
          let value = data.convert
          if (typeof value === 'number') {
            if (value < this.passScore) {
              return true
            }
          }
        }
      }
    },
    scoreErr () {
      let state = this.state
      if (state && state.type === 'fail') {
        return true
      }
    }
  },
  methods: {
    show () {
      this.visible = true
    },
    hide () {
      this.visible = false
    },
    onInput (val) {
      this.input = val
    },
    handleReady () {
      this.ready = true
    },
    handlePretty () {
      let state = this.state
      if (state && state.data) {
        this.input = scoreComputeUtils.prettyScore({scoreAlias: this.scoreAlias, displayFraction: this.displayFraction},
          state.data.name, state.data.convert)
      }
    },
    handleSelect (val) {
      this.input = val
      this.$nextTick(() => this.hide())
    }
  },
  watch: {
    value (val) {
      this.input = val
    },
    input (val) {
      this.$emit('input', val)
    },
    state (val) {
      if (val && val.data) {
        this.$emit('on-input', val.data.convert)
      } else {
        this.$emit('on-input', null)
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../styles/color";
  .biz-score-picker {
    .biz-score-picker-input {
      &.is-fail {
        .el-input__inner {
          color: $set-danger-color;
        }
      }
      &.is-err {
        .el-input__inner {
          border-color: $set-danger-color;
        }
      }
      .el-input__suffix {
        display: flex;
        align-items: center;
        & > .el-input__suffix-inner {
          position: relative;
          top: -1px;
          .state-success,
          .state-fail {
            padding-right: 5px;
            i {
              font-size: 14px;
              vertical-align: -1px;
            }
          }
          .state-success {
            color: $set-success-color;
          }
          .state-fail {
            color: $set-danger-color;
          }
        }
      }
    }
  }
  .biz-score-picker-popover {
    min-width: 240px!important;
    max-width: 320px!important;
    padding: 12px!important;
  }
</style>
